import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Data } from '../../core/services/data';
import { Verein } from '../../core/models/verein';

@Component({
  selector: 'app-vereine',
  imports: [CommonModule],
  templateUrl: './vereine.html',
  styleUrl: './vereine.css'
})
export class Vereine implements OnInit {
  private dataService = inject(Data);

  vereine = signal<Verein[]>([]);
  isLoading = signal<boolean>(false);
  errorMessage = signal<string>('');

  ngOnInit() {
    this.loadVereine();
  }

  loadVereine() {
    this.isLoading.set(true);
    this.dataService.getVereine().subscribe({
      next: (vereine) => {
        this.vereine.set(vereine);
        this.isLoading.set(false);
      },
      error: (error) => {
        this.errorMessage.set('Fehler beim Laden der Vereinsdaten');
        this.isLoading.set(false);
        console.error('Error loading vereine:', error);
      }
    });
  }

  hasUrl(verein: Verein): boolean {
    return verein.Url !== null && verein.Url !== undefined && verein.Url.trim() !== '';
  }
}
